/* eslint-disable camelcase */
import { faCircleCheck, faCompass } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { toHHMM } from '../../../utils/formatTime';
import { getProgramTypeBadgeClass } from '../../../utils/minside/activities';

function ProgramChoiceCard({ aktivitet, checked, onToggle, disabled = false, erFull = false }) {
    return (
        <label
            className={`program-choice ${checked ? 'is-selected' : ''} ${disabled ? 'is-disabled' : ''}`}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={() => onToggle(aktivitet.akt_id)}
                disabled={disabled}
            />

            <div className="program-choice__content">
                <div className="program-choice__top">
                    <span className="program-choice__time">
                        {toHHMM(aktivitet.fratid)}–{toHHMM(aktivitet.tiltid)}
                    </span>

                    {aktivitet.type_navn && (
                        <span
                            className={`program-type-badge ${getProgramTypeBadgeClass(
                                aktivitet.type_navn
                            )}`}
                        >
                            {aktivitet.type_navn}
                        </span>
                    )}
                </div>

                <h4 className="program-choice__title">{aktivitet.tittel}</h4>

                {aktivitet.sted && (
                    <div className="program-choice__location">
                        <FontAwesomeIcon icon={faCompass} />
                        {aktivitet.sted}
                    </div>
                )}

                {checked && (
                    <span className="program-choice__selected">
                        <FontAwesomeIcon icon={faCircleCheck} />
                    </span>
                )}

                {erFull && !checked && <span className="program-choice__full">Fullt</span>}
            </div>
        </label>
    );
}

export default ProgramChoiceCard;
